import { createDrawerNavigator } from "@react-navigation/drawer";
import { NavigationContainer } from "@react-navigation/native";
import { useContext } from "react";
import { Image, Platform, StyleSheet, View } from "react-native";
import BooksContextProvider from "../globalData/BooksContext";
import { CommunityContext } from "../globalData/ComunityContext";
// import Goal from "../screens/MyInfo";
import CommInfo from "../screens/CommInfo";
import NotifStack from "./NotifStack";

const Drawer = createDrawerNavigator();

//export default function DrawerNav({ route, navigation }) {
export default function DrawerNav() {
  const communityInfo = useContext(CommunityContext);
  let comName = communityInfo.currCom.cName;
  if (comName.length > 10 && Platform.OS != "web")
    comName = comName.substring(0, 10) + "...";
  return (
    <BooksContextProvider>
      <NavigationContainer>
        <Drawer.Navigator
          screenOptions={{
            drawerActiveBackgroundColor: "#E2CFC2",
            drawerActiveTintColor: "#56494C",
            drawerStyle: {
              backgroundColor: "#A48578",
            },
            headerStyle:
              Platform.OS == "web"
                ? { backgroundColor: "#E2CFC2", marginTop: 10 }
                : {
                    backgroundColor: "#56494C",
                    height: 130,
                  },
            headerTintColor: "#A48578",
            headerTitleStyle: {
              fontFamily: "fasthand",
              fontSize: 35,
            },
            headerRight: () => (
              <View style={{ flexDirection: "row" }}>
                <Image
                  source={require("../assets/logo.png")}
                  style={{ ...styles.logo, marginRight: 0 }}
                  resizeMode={"contain"}
                />
                <Image
                  source={require("../assets/OBOCLogo.png")}
                  style={styles.logo}
                  resizeMode={"contain"}
                />
              </View>
            ),
          }}
        >
          <Drawer.Screen
            name="Main"
            component={NotifStack}
            options={{
              title: comName,
              drawerLabel: communityInfo.currCom.cName + " Books",
            }}
          />
          <Drawer.Screen name={"Users"} component={CommInfo} />
          {/* <Drawer.Screen name={"Your Goal"} component={Goal} /> */}
        </Drawer.Navigator>
      </NavigationContainer>
    </BooksContextProvider>
  );
}

const styles = StyleSheet.create({
  logo: {
    marginTop: -15,
    marginRight: 10,
    width: 60,
    height: 60,
  },
});
